import { render, staticRenderFns } from "./vendor-profile.vue?vue&type=template&id=ec96a004&"
import script from "./vendor-profile.vue?vue&type=script&lang=js&"
export * from "./vendor-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports